import React, { useState } from 'react';
import ModalOverlay from '../../shared/ModalOverlay';

interface DateChange {
  field: string;
  oldVal: string;
  newVal: string;
}

interface ChangeReasonModalProps {
  active: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  changes: DateChange[];
}

const ChangeReasonModal: React.FC<ChangeReasonModalProps> = ({ active, onClose, onConfirm, changes }) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason);
    setReason('');
  };

  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-sm">
        <div className="modal-header">
          <h2>Change Reason</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div style={{ padding: '1rem 1.5rem' }}>
          <p style={{ marginBottom: '0.75rem', color: 'var(--text-dim)', fontSize: '0.85rem' }}>
            {changes.map((c, i) => (
              <span key={i}>
                {c.field}: {c.oldVal || 'empty'} &rarr; {c.newVal || 'empty'}
                {i < changes.length - 1 && <br />}
              </span>
            ))}
          </p>
          <div className="form-group">
            <label>Reason for Change</label>
            <textarea
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              required
              style={{ width: '100%' }}
              placeholder="Enter the reason for this date change..."
            />
          </div>
        </div>
        <div className="form-actions">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleConfirm} disabled={!reason.trim()}>Confirm</button>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default ChangeReasonModal;
